import fp from 'lodash/fp';
import React from 'react';
import { noCapMap } from '../../utils';

const GeneralTable = ({ rows, headerRows, columns, className }) => (
  <table className={className}>
    <thead>
      <tr>
        {
          fp.map(
            (column) => <td key={column.key} className={column.className}>{column.name}</td>
          )(columns)
        }
      </tr>
      {
        noCapMap(
          (row, rid) => (
            <tr key={rid}>
              {
                noCapMap(
                  (span, cid) => (
                    <td key={cid} className={span.className} colSpan={span.width}>{span.value}</td>
                  )
                )(row)
              }
            </tr>
          )
        )(headerRows)
      }
    </thead>
    <tbody>
      {
        noCapMap(
          (row, rid) => (
            <tr key={rid}>
              {
                fp.map(
                  (column) => <td key={column.key} className={row[column.key].className}>
                    {
                      row[column.key].value
                    }
                  </td>
                )(columns)
              }
            </tr>
          )
        )(rows)
      }
    </tbody>
  </table>
);

export default GeneralTable;


// WEBPACK FOOTER //
// ./src/containers/components/general-table.js